import {
  BasicButton,
  ButtonGroup,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  PrimaryButton,
  Text,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export function CancelModal() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Dialog>
      {({ close }) => (
        <>
          <DialogHeader>{t("Discard changes")}</DialogHeader>
          <DialogContent>
            <Text style="form/body-secondary" color="text-weak">
              <Trans>Details you have entered will not be saved.</Trans>
            </Text>
          </DialogContent>
          <DialogFooter>
            <ButtonGroup>
              <BasicButton
                testID="cancel-modal-cancel-button"
                size="medium"
                onPress={() => {
                  close();
                }}
              >
                <Trans>Cancel</Trans>
              </BasicButton>
              <PrimaryButton
                testID="cancel-modal-discard-button"
                onPress={async () => {
                  navigate("/settings/questionnaire-templates");
                  close();
                }}
                size="medium"
              >
                <Trans>Discard template</Trans>
              </PrimaryButton>
            </ButtonGroup>
          </DialogFooter>
        </>
      )}
    </Dialog>
  );
}
